var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5L18.375 10.5M10.5 2.625L10.5 18.375M6.825 2.625H14.175C15.6451 2.625 16.3802 2.625 16.9417 2.91111C17.4357 3.16278 17.8372 3.56435 18.0889 4.05827C18.375 4.61979 18.375 5.35486 18.375 6.825V14.175C18.375 15.6451 18.375 16.3802 18.0889 16.9417C17.8372 17.4357 17.4357 17.8372 16.9417 18.0889C16.3802 18.375 15.6451 18.375 14.175 18.375H6.825C5.35486 18.375 4.61979 18.375 4.05827 18.0889C3.56435 17.8372 3.16278 17.4357 2.91111 16.9417C2.625 16.3802 2.625 15.6451 2.625 14.175V6.825C2.625 5.35486 2.625 4.61979 2.91111 4.05827C3.16278 3.56435 3.56435 3.16278 4.05827 2.91111C4.61979 2.625 5.35486 2.625 6.825 2.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateActive);
export default __webpack_public_path__ + "static/media/template-active.15ffc002cc643d6bae211431fd9c0c27.svg";
export { ForwardRef as ReactComponent };